var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoConversation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 325.1 262.8",
    style: {
      enableBackground: "new 0 0 325.1 262.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#CFCFCF;}\n\t.st2{fill:none;stroke:#BABABA;stroke-width:2.365;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:#FFFFFF;stroke:#BABABA;stroke-width:2.365;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:#BABABA;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.1,97.5c-19.8,0-39.9-0.8-58.8-6.1c-18.5-5.2-35.5-15.1-50.6-26.6c-9.9-7.5-18.9-13.5-31.8-12.6 c-12.6,0.7-24.6,5.3-34.3,13.3c-16.4,14.3-13.9,40.8-7.4,59.5c9.9,28.1,39.8,47.6,65.3,60.3c29.4,14.7,61.7,23.3,94.1,28 c28.4,4.3,64.8,7.4,89.4-11.1c22.6-17,28.8-55.9,23.3-82.2c-1.3-7.8-5.5-14.8-11.6-19.7c-15.9-11.6-39.5-3.9-57.4-3.5 C224.6,97.2,217.9,97.5,211.1,97.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.6,259.5c47.9,0,86.8-2.4,86.8-5.4c0-3-38.9-5.4-86.8-5.4c-47.9,0-86.8,2.4-86.8,5.4 C75.8,257.1,114.7,259.5,162.6,259.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M286.7,64c1.3,0,2.3-1,2.3-2.3c0-1.3-1-2.3-2.3-2.3c-1.3,0-2.3,1-2.3,2.3C284.4,63,285.4,64,286.7,64z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M186.8,47.5c1.3,0,2.3-1,2.3-2.3c0-1.3-1-2.3-2.3-2.3s-2.3,1-2.3,2.3C184.5,46.5,185.5,47.5,186.8,47.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.2,197.8V208"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M89.1,202.9h10.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.9,4.2v10.2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.8,9.3H62"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M241.3,56.6v10.2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M236.2,61.7h10.2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M149.2,192.8c10.9,15.3,27.5,25.6,46,28.7c18.5,3.1,37.5-1.3,52.8-12.1c1.9-1.3,3.7-2.8,5.5-4.3l28.2,8.5 L270.9,182c5.4-11.3,7.7-23.8,6.7-36.3c-1-12.5-5.3-24.5-12.4-34.7c-7.1-10.3-16.9-18.5-28.2-23.8c-11.3-5.3-23.9-7.5-36.3-6.4 c-12.5,1.1-24.4,5.5-34.6,12.7c-10.2,7.2-18.4,17-23.6,28.4c-5.2,11.4-7.3,23.9-6.1,36.4C137.5,170.7,141.9,182.6,149.2,192.8 L149.2,192.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M231.5,156.3c2.6,0,4.7-2.1,4.7-4.7s-2.1-4.7-4.7-4.7c-2.6,0-4.7,2.1-4.7,4.7S228.9,156.3,231.5,156.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M208.9,156.3c2.6,0,4.7-2.1,4.7-4.7s-2.1-4.7-4.7-4.7c-2.6,0-4.7,2.1-4.7,4.7S206.3,156.3,208.9,156.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M186.3,156.3c2.6,0,4.7-2.1,4.7-4.7s-2.1-4.7-4.7-4.7c-2.6,0-4.7,2.1-4.7,4.7S183.7,156.3,186.3,156.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M172.4,144.5c-10.9,15.3-27.5,25.6-46,28.7c-18.5,3.1-37.5-1.3-52.8-12.1c-1.9-1.3-3.7-2.8-5.5-4.3l-28.2,8.6 l10.8-31.6c-5.4-11.3-7.7-23.8-6.7-36.3C45,85,49.3,73,56.4,62.7c7.1-10.3,16.9-18.5,28.2-23.8c11.3-5.3,23.9-7.5,36.3-6.4 c12.5,1.1,24.4,5.5,34.6,12.7c10.2,7.2,18.4,17,23.6,28.4c5.2,11.4,7.3,23.9,6.1,36.4C184.1,122.4,179.6,134.3,172.4,144.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M94.5,117.1c2.1-3.5,5.1-6.5,8.6-8.5c3.6-2.1,7.6-3.2,11.7-3.2c4.1,0,8.2,1,11.8,3c3.6,2,6.6,4.9,8.8,8.4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M141.5,96.3c1.8,0,3.3-1.5,3.3-3.3c0-1.8-1.5-3.3-3.3-3.3c-1.8,0-3.3,1.5-3.3,3.3 C138.2,94.8,139.6,96.3,141.5,96.3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M88.7,96.3c1.8,0,3.3-1.5,3.3-3.3c0-1.8-1.5-3.3-3.3-3.3s-3.3,1.5-3.3,3.3C85.3,94.8,86.8,96.3,88.7,96.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoConversation);
export default __webpack_public_path__ + "static/media/no-conversation.fe6627976408697e7be708f35e561e57.svg";
export { ForwardRef as ReactComponent };